import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import AutoLogin from '@/components/AutoLogin'
import Home from '@/components/Home'
import Recharge from '@/components/Recharge'
import withdrawdeposit from '@/components/withdrawdeposit'
import history from '@/components/history'
import personaldata from '@/components/personaldata'
import index from '@/components/index'
import bankcode from '@/components/modification/bankcode'
import usdtaccount from '@/components/modification/usdtaccount'
import phone from '@/components/modification/phone'
import unbindphone from '@/components/modification/unbindphone'
import personid from '@/components/modification/personid'
import register from '@/components/register'
import forgetPswd from '@/components/forgetPswd'  
import registersuccess from '@/components/registersuccess'
import contactadministrator from '@/components/ContactAdministrator';

let Rurl = localStorage.getItem("url")
if (Rurl == null) {
  Rurl = "/login/"
} else {
  Rurl = Rurl.split("#")[1]
}

Vue.use(Router)

export default new Router({
    routes: [{
            path: '/',
            redirect: Rurl,
        },
        {
            path: '/Login/:id',
            component: Login
        },
        {
          path: '/Login/',
          component: Login
        },
        {
            path: '/AutoLogin',
            component: AutoLogin
        },
        {
            path: '/register',
            component: register
        },
		{
		    path: '/contactadministrator',
		    component: contactadministrator
		},
        {
            path: '/register/:id',
            component: register
        },
        {
            path: '/register/:id/:id',
            component: register
        },
        {
            path: '/forgetPswd',
            component: forgetPswd
        },
        {
            path: '/registersuccess',
            component: registersuccess
        },        
        {
            path: '/forgetPswd/:id/:id',
            component: forgetPswd
        },
        {
            path: '/index',
            component: Home,
            children: [{
                    path: '/index',
                    component: index
                },
                {
                    path: '/Recharge',
                    component: Recharge
                }, {
                    path: '/withdrawdeposit',
                    component: withdrawdeposit
                }, {
                    path: '/history',
                    component: history
                }, {
                    path: '/personaldata',
                    component: personaldata
                }, {
                    path: '/modification/phone',
                    component: phone
                }, {
                    path: '/modification/unbindphone',
                    component: unbindphone
                }, {
                    path: '/modification/bankcode',
                    component: bankcode
                }, {
                    path: '/modification/usdtaccount',
                    component: usdtaccount
                }, {
                    path: '/modification/personid',
                    component: personid
                }

            ]
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js